const detailsMixins = {
    props: {
        gateway: {
            type: Object,
        },
    },
};
export default detailsMixins;
